import Anchor from "@components/controls/Anchor";
import MimeTypes from "@core-ui/ApiServices/Types/MimeTypes";
import ResourceService from "@core-ui/ContextServices/ResourceService/ResourceService";
import t from "@ext/localization/locale/translate";
import { openFilePreview } from "@ext/markdown/elements/file/edit/logic/openFilePreview";
import { toast } from "@ui-kit/Toast";
import type { MouseEvent, ReactNode } from "react";
import Path from "../../../../../../logic/FileProvider/Path/Path";
import { downloadFile } from "../../../../../../ui-logic/downloadResource";

interface LinkProps {
	resourcePath: string;
	isFile: boolean;
	children: ReactNode;
}

const Link = (props: LinkProps) => {
	const { isFile, resourcePath, ...otherProps } = props;
	// The article holding the link, a fragment of another catalog too, is where the file lies.
	const resources = ResourceService.value;

	if (!isFile) return <Anchor href={null} {...otherProps} resourcePath={resourcePath} />;

	const onClickHandler = async (event: MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		event.stopPropagation();

		const path = new Path(resourcePath);
		const onError = () => {
			toast(t("file-not-found"), {
				status: "error",
				icon: "triangle-alert",
				description: t("file-download-error-message"),
				size: "lg",
			});
		};

		const { buffer, error } = await resources.loadResource(path.value);
		if (error || !buffer) return onError();

		const download = () =>
			downloadFile(
				buffer,
				MimeTypes[path.extension] ?? path.extension,
				decodeURIComponent(path.nameWithExtension),
			);
		openFilePreview(buffer, path, { onError, downloadResource: download });
	};

	return (
		<button className="link" onClick={onClickHandler} type="button">
			{otherProps.children}
		</button>
	);
};

export default Link;
